import { Project } from "../types";

export const setters: Project = {
  id: 9,
  shortie: true,
  name: {
    en: "SETTERS AGENCY",
    ru: "SETTERS AGENCY",
  },
  similarCases: [4, 7, 2],
  type: {
    en: "Corporate",
    ru: "Рабочее",
  },
  year: "2024",
  timeline: {
    en: "Mar'24 — Jun'24",
    ru: "Март 24 — Июнь 24",
  },
  short_deliverables: {
    en: "Brand & Product",
    ru: "Бренд и продукт",
  },
  deliverables: {
    en: "Branding, Identity, Analytics, Promotion ",
    ru: "Брендинг, Айдентика, Аналитика, Продвижение",
  },
  filterTags: [
    {
      name: { en: "Product design", ru: "Продуктовый дизайн" },
      value: "product",
    },
    {
      name: { en: "Art direction", ru: "Арт-дирекшн" },
      value: "artdir",
    },
  ],
  role: {
    en: "Art director",
    ru: "Арт-директор",
  },
  organisation: "Toggle Studio",
  team: [
    {
      imageSrc:
        "https://firebasestorage.googleapis.com/v0/b/ttovarischh-9c624.appspot.com/o/design%2FtoggleAvatar.webp?alt=media&token=e7ddab7c-1177-4c8a-95b0-397909b7d741",
      link: "https://www.behance.net/toggle_studio",
    },
    {
      imageSrc:
        "https://firebasestorage.googleapis.com/v0/b/ttovarischh-9c624.appspot.com/o/design%2Fpolina.webp?alt=media&token=d1bec526-b4aa-47ac-ba48-85c4e20d6377",
      link: "https://eto-polia.com/",
    },
  ],
  status: {
    en: "Finished",
    ru: "Завершено",
  },
  s_description: {
    en: "Rebranding of an award-winning creative agency.",
    ru: "Ребрендинг смелого российского кретивного агенства.",
  },
  description: {
    en: "SETTERS is known for blending bold strategy with cultural relevance — working with top brands like Kaspersky Lab, Yandex, and Netflix, as well as local disruptors. Their open, collaborative approach and constant evolution aligned closely with Toggle Studio mindset: curious, flexible, and always ready to try something new. That’s why we didn’t hesitate to take on the redesign of this well-known creative agency.",
    ru: "SETTERS умеют сочетать смелую стратегию с тонким чувством культурного контекста. Они работают как с крупнейшими брендами — Kaspersky Lab, Yandex, Netflix, — так и с локальными креаторами. Их стиль — сотрудничество на равных, живой диалог и постоянное развитие — во многом перекликается с мышлением Toggle Studio: нам близка жажда нового, гибкость и готовность пробовать неизведанное. Поэтому мы с командой с энтузиазмом взялись за редизайн этого небезызвестного креативного агентства.",
  },
  vertical_cover:
    "https://firebasestorage.googleapis.com/v0/b/ttovarischh-9c624.appspot.com/o/setters%2FSetters_v_cover.webp?alt=media&token=16726282-48e7-45f4-9eb3-4795f613c58e",
  horisontal_cover:
    "https://firebasestorage.googleapis.com/v0/b/ttovarischh-9c624.appspot.com/o/setters%2FSetters_h_cover.webp?alt=media&token=6930cbb5-ae11-4e2e-96e5-e9969e49ab6f",
  cover:
    "https://firebasestorage.googleapis.com/v0/b/ttovarischh-9c624.appspot.com/o/setters%2FSetters_Web_Cover.gif?alt=media&token=b3c1997d-e9ea-4def-9d86-6b6a64b0af53",
  cover_mob:
    "https://firebasestorage.googleapis.com/v0/b/ttovarischh-9c624.appspot.com/o/setters%2FSetters_Mob_Cover.gif?alt=media&token=f0300245-e592-4c24-b174-a96de38f66c7",
  links: [
    {
      name: {
        en: "SETTERS",
        ru: "SETTERS",
      },
      url: "https://www.setters.agency/",
    },
    {
      name: {
        en: "Behance",
        ru: "Behance",
      },
      url: "https://www.behance.net/gallery/223843079/SETTERS-AGENCY-Rebranding",
    },
  ],
  slider: [],
  link_cards: [],
  images: [],
  texts: [],
  layout: [],
  menuItems: [],
};
